// Tailwind color tokens mapped to playful subject badge styles
export const SUBJECT_COLORS = {
  amber: { bg: "bg-amber-100", text: "text-amber-900", border: "border-amber-300", dot: "bg-amber-500", solid: "bg-amber-500" },
  sky: { bg: "bg-sky-100", text: "text-sky-900", border: "border-sky-300", dot: "bg-sky-500", solid: "bg-sky-500" },
  emerald: { bg: "bg-emerald-100", text: "text-emerald-900", border: "border-emerald-300", dot: "bg-emerald-500", solid: "bg-emerald-500" },
  purple: { bg: "bg-purple-100", text: "text-purple-900", border: "border-purple-300", dot: "bg-purple-500", solid: "bg-purple-500" },
  teal: { bg: "bg-teal-100", text: "text-teal-900", border: "border-teal-300", dot: "bg-teal-500", solid: "bg-teal-500" },
  rose: { bg: "bg-rose-100", text: "text-rose-900", border: "border-rose-300", dot: "bg-rose-500", solid: "bg-rose-500" },
  indigo: { bg: "bg-indigo-100", text: "text-indigo-900", border: "border-indigo-300", dot: "bg-indigo-500", solid: "bg-indigo-500" },
  orange: { bg: "bg-orange-100", text: "text-orange-900", border: "border-orange-300", dot: "bg-orange-500", solid: "bg-orange-500" },
};

export const COLOR_OPTIONS = Object.keys(SUBJECT_COLORS);

export function colorOf(token) {
  return SUBJECT_COLORS[token] || SUBJECT_COLORS.sky;
}

export const DAYS = ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"];

export const MONTHS = ["Eylül", "Ekim", "Kasım", "Aralık", "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos"];

// Sınıf sistemi: İlkokul (1-4) + Ortaokul (5-7)
export const GRADES = [1, 2, 3, 4, 5, 6, 7];
export const GRADE_GROUPS = [
  { label: "İlkokul", grades: [1, 2, 3, 4] },
  { label: "Ortaokul", grades: [5, 6, 7] },
];
export const schoolOfGrade = (g) => (Number(g) >= 5 ? "Ortaokul" : "İlkokul");
export const GRADE_COLORS = ["bg-amber-500", "bg-sky-500", "bg-emerald-500", "bg-rose-500", "bg-indigo-500", "bg-purple-500", "bg-teal-500"];
// 4 ve 7. sınıfa özel sınav takip paneli
export const EXAM_TRACK_GRADES = [4, 7];

export const trUpper = (s = "") => s.toLocaleUpperCase("tr-TR");

export const ROLE_LABELS = {
  admin: "Yönetici",
  koc: "Koç",
  ogrenci: "Öğrenci",
  veli: "Veli",
};
